<ft-sheet-tabs state-array="sheetTabs"><div class="sheet-tabs"><ul></ul></div></ft-sheet-tabs>

<div class="ft-section contest-snapshot-section">
  <div class="ft-container">
    <div class="stats submissions">
      <div class="stat">
        <div class="ft-count">{{ model().contest?.totalPhotoSubmissions | number }}</div>
        <div class="desc">
          {{ 'flipto.account.sections.platform.photoAdvocacy.Submissions' | translate }}
        </div>
        <!--BOTH-->
        @if (model().contest?.totalInviteePhotoSubmissions > 0 && model().contest?.totalInviteePhotoSubmissions < model().contest?.totalPhotoSubmissions) {
          <div class="detail">
            {{ model().contest.totalPhotoSubmissions - model().contest.totalInviteePhotoSubmissions | number }} {{ (model().contest.totalPhotoSubmissions - model().contest.totalInviteePhotoSubmissions > 1 ? 'flipto.account.sections.platform.photoAdvocacy.Guests' : 'flipto.account.sections.platform.photoAdvocacy.Guest') | translate }},
            {{ model().contest.totalInviteePhotoSubmissions | number }} {{ (model().contest.totalInviteePhotoSubmissions > 1 ? 'flipto.account.sections.platform.photoAdvocacy.Invitees' : 'flipto.account.sections.platform.photoAdvocacy.Invitee') | translate }}
          </div>
        }
        <!--PURE GUEST-->
        @if (model().contest?.totalInviteePhotoSubmissions <= 0 && model().contest?.totalPhotoSubmissions > 0) {
          <div class="detail">
            {{ 'flipto.account.sections.platform.photoAdvocacy.FromGuests' | translate }}
          </div>
        }
        <!--PURE INVITEE-->
        @if (model().contest?.totalInviteePhotoSubmissions >= model().contest?.totalPhotoSubmissions && model().contest?.totalPhotoSubmissions > 0) {
          <div class="detail">
            {{ 'flipto.account.sections.platform.photoAdvocacy.FromInvitees' | translate }}
          </div>
        }
      </div>
    </div>
    <div class="stats finalists">
      <div class="stat">
        <div class="ft-count">{{ model().contest?.totalFinalists | number }}</div>
        <div class="desc">
          {{ 'flipto.account.sections.platform.photoAdvocacy.Finalists' | translate }}
        </div>
        <div class="detail">
          {{ model().contestInfo?.totalShares | number }}
          {{ 'flipto.account.TotalSharesByStorytellersAndFriends' | translate }}
        </div>
      </div>
    </div>
    <div class="stats contest-progress">
      <div class="contest-stats-heading">
        <ft-contest-status [contest]="model().contestInfo" />
      </div>

      <ft-ranking>
        <ft-rank-slot place-type="first" winner="model.contest.firstPlace"
                      incentive="model.finalistsIncentives.firstWinnerIncentive" />
        <ft-rank-slot place-type="second" winner="model.contest.secondPlace"
                      incentive="model.finalistsIncentives.secondWinnerIncentive" />
        <ft-rank-slot place-type="third" winner="model.contest.thirdPlace"
                      incentive="model.finalistsIncentives.thirdWinnerIncentive" />
        <ft-rank-runner-ups winners="model.contest.runnerUps"
                            total-runner-ups="model.finalistsIncentives.runnerUpsIncentive['@totalRunnerUps']" />
      </ft-ranking>

      <a class="btn-select-winners" (click)="onReviewFinalists()">
        {{ 'flipto.account.sections.platform.photoAdvocacy.ReviewFinalists' | translate }}
        <i class="ft-icn-arrow-right"></i>
      </a>
    </div>
  </div>
</div>

<div class="ft-section contest-stories-list-section">
  <div class="ft-container">
    <!-- Convert this into ft-contexttabs-nav for v2 when we phase out v1 -->
    <div class="ft-section-header">
      <div class="ft-row">
        <div class="ft-col-left">
          <div class="ft-label">
            {{ pluralCount }} {{ (pluralCount === 1 ? 'flipto.account.sections.platform.photoAdvocacy.Submission' : 'flipto.account.sections.platform.photoAdvocacy.Submissions') | translate }}
          </div>
        </div>
        <div class="ft-col-center">
          <div class="ft-view-toggle ft-btn-group">
            <div class="ft-btn" [class.active]="screen() === 'new'" (click)="screen.set('new')">
              {{ 'flipto.account.sections.platform.photoAdvocacy.New' | translate }}
            </div>
            <div class="ft-btn" [class.active]="screen() === 'curated'" (click)="screen.set('curated')">
              {{ 'flipto.account.sections.platform.photoAdvocacy.Curated' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div [hidden]="screen() !== 'new'">
      <div class="ft-contexttab-view active">
        <div class="ft-row">
          @for (submission of newSubmissions; track submission) {
            <div class="ft-col-33">
              <div class="ft-panel entry-photo"
                   (click)="openPhotoCuration(submission)"
                   [ftBackgroundImage]="submission.photoUrl">
                <div class="photo-info submission">
                  <ft-image-ng [src]="submission.profileImageUrl" [profilePhoto]="true" />
                  <div class="ft-label">{{ submissionStateName(submission) }}</div>
                </div>
              </div>
            </div>
          }
        </div>
        @if (!newSubmissions.length) {
          <div class="placeholder-panel">
            {{ 'flipto.account.ThereAreNoNewSubmissions' | translate }}
          </div>
        }
      </div>
    </div>

    <div [hidden]="screen() !== 'curated'">
      <div class="ft-contexttab-view active">
        <div class="ft-row">
          @for (submission of curatedSubmissions; track submission) {
            <div class="ft-col-33">
              <div class="ft-panel entry-photo"
                   (click)="openPhotoCuration(submission)"
                   [ftBackgroundImage]="submission.photoUrl">
                <div class="photo-info submission">
                  <ft-image-ng [src]="submission.profileImageUrl" [profilePhoto]="true" />
                  <div class="ft-label">{{ submissionStateName(submission) }}</div>
                </div>
              </div>
            </div>
          }
          @if (model().hasMoreData) {
            <div class="infinitescroll-load-container">
              <button class="ft-btn ft-btn-outline-dark" (click)="loadNextPage()">
                {{ 'flipto.account.LoadMore' | translate }}
              </button>
            </div>
          }
        </div>
        @if (!curatedSubmissions.length) {
          <div class="placeholder-panel">
            {{ 'flipto.account.ThereAreNoCuratedSubmissions' | translate }}
          </div>
        }
      </div>
    </div>
  </div>
</div>
